<script setup lang="ts">
import type { SlugBodyItem } from '.';

defineProps<{ items: SlugBodyItem[] }>();

const text = {
  title: 'Co všechno nabízíme?',
  marquee: 'Trénink & Adrenalin',
} as const;
</script>

<template>
  <PageContainerAlignment
    no-padding
    no-alignment
    as="section"
    class="bg-client-black py-r12 lg:pb-r18 flex flex-col lg:pt-0"
  >
    <PageContainerAlignment
      class="py-r12 lg:py-r18 gap-r12 lg:gap-r18 flex flex-col"
    >
      <AppHeading tag="h2" class="text-client-orange lg:text-center">
        {{ text.title }}
      </AppHeading>
      <SlugBodyItemContainer :items />
    </PageContainerAlignment>
    <Marquee>
      <span class="text-client-white block leading-[100%] font-bold">
        {{ text.marquee }}
      </span>
    </Marquee>
  </PageContainerAlignment>
</template>
